
import axiosInstance from "utils/axios-request";
import {baseUrl, gatewayUrl} from "config";
import {IUTMParams} from "StateInterface";
import {IProfile} from "StateInterface";
import {getIdToken} from "service";
import {ILatestStatus} from "profile/interface";

export const getProfile = (userId: number) =>
    axiosInstance.request({
        baseURL: baseUrl,
        url: `lam/status/${userId}`,
        method: "get",
    });

export const saveLamProfile = (
    userId: number,
    profileData: object,
    sourcingCode: string,
    utmParams: IUTMParams,
) =>
    axiosInstance.request({
        baseURL: gatewayUrl,
        url: `paandu/profile?userId=${userId}`,
        method: "post",
        data: {
            profileData,
            sourcingCode,
            utmParams,
        },
        timeout: 30000,
    });

export const requestOtp = (mobile: number) =>
    axiosInstance.request({
        baseURL: gatewayUrl,
        url: "paandu/generate-mobile-otp",
        method: "get",
        params: {mobile},
    });

export const validateOtp = (mobile: string, otp: number) =>
    axiosInstance.request({
        baseURL: gatewayUrl,
        url: "paandu/verify-mobile-otp",
        method: "post",
        data: {
            mobile,
            otp,
        },
    });

export const getLamProfile = async (): Promise<IProfile> => {
    const response = await axiosInstance.request({
        baseURL: gatewayUrl,
        url: "/paandu/profile",
        method: "get",
    });
    return response.data.profileData;
};

export const getLatestApplicationStatus = async (): Promise<ILatestStatus> => {
    const response = await axiosInstance.request({
        baseURL: gatewayUrl,
        url: "paandu/latest-application-status?translate_status=False",
        method: "get",
    });
    return response.data;
};
